'use strict';

import $ from 'jquery';
import Popover from 'bootstrap/js/src/popover';
// import mpro from './mpro.init';

class MpPopover extends Popover {

	constructor(element, config) {
		super(element, config);
		// Attach the instance to the element
		// @ts-ignore
		this._element._popover = this;
	}

	dispose() {
		// Detach the instance from the element
		// @ts-ignore
		this._element._popover = null;
		super.dispose();
	}
}

// So we separate the containers (one on the body (tooltip) and one just below the body (popover))
export const bodyPopover = new MpPopover(document.querySelector('[data-popover-container]'), {
	html: true,
	selector: '[data-bs-toggle="popover"]',
	container: document.body,
});

// Close Popovers
mpro.removePopovers = function($container) {

	// Remove bs5 popovers
	for (const element of $('[data-bs-toggle="popover"]', $container)) {
		try {
			// @ts-ignore
			element._popover && element._popover.dispose();
		}
		catch (e) {
			console.warn('Error while trying to dispose popover instance for element (%o): %o', element, e);
		}
	}
};

export default mpro;
